// @ts-check
import React from 'react'

const ValidIcon = ({ className }) => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <circle cx='10' cy='10' r='10' fill='#1FA86F' />
    <path d='M0 2.5L3 5.5L8.5 0' transform='translate(6 7.5)' stroke='white' strokeWidth='1.75' />
  </svg>
)

export { ValidIcon }
